import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import { useImagensSection } from "./use-imagens-section";
import { ImagensSectionView } from "./view-imagens-section";

export function ImagensSection(props: EmbarcacaoDetailSectionProps) {
  const vm = useImagensSection(props);

  return <ImagensSectionView {...vm} />;
}

export type * from "./types-imagens-section";
